import { ConfidentialityConfiguration } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { ConfidentialityEditModal } from './ConfidentialityEditModal';

type ConfidentialityEditModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type ConfidentialityEditModalOpenerProps = {
   confidentialityConfiguration: ConfidentialityConfiguration;
   children: (renderProps: ConfidentialityEditModalOpenerRenderProps) => JSX.Element;
};

export const ConfidentialityEditModalOpener = (props: ConfidentialityEditModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <ConfidentialityEditModal
               confidentialityConfiguration={props.confidentialityConfiguration}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
